import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

export function useRouteCostTranslations(distance_unit = '') {
	const { t } = useTranslation();

	const _translationKeys = useMemo(() => {
		return {
			routeCost: 'VEHICLE_PROFILES.FORM.ROUTE_COST',
			routeCostDescription: 'VEHICLE_PROFILES.FORM.ROUTE_COST_DESCRIPTION',
			costCalculationMethod: 'VEHICLE_PROFILES.FORM.COST_CALCULATION_METHOD',
			overallCostPerMinute: 'VEHICLE_PROFILES.FORM.OVERALL_COST_PER_MINUTE',
			overallCostPerMinuteLabel: 'VEHICLE_PROFILES.FORM.OVERALL_COST_PER_MINUTE_LABEL',
			costPerMinuteDriving: 'VEHICLE_PROFILES.FORM.COST_PER_MINUTE_DRIVING',
			costPerKm: ['VEHICLE_PROFILES.FORM.COST_PER_KM', { distance_unit: distance_unit.toLowerCase() }],
			costPerRoute: 'VEHICLE_PROFILES.FORM.COST_PER_ROUTE',
			costPerTos: 'VEHICLE_PROFILES.FORM.COST_PER_TOS',
			costPerStop: 'VEHICLE_PROFILES.FORM.COST_PER_STOP',
			costPerMinuteWaiting: 'VEHICLE_PROFILES.FORM.COST_PER_MINUTE_WAITING',
			orderCostPercentage: 'VEHICLE_PROFILES.FORM.ORDER_COST_PERCENTAGE',
			orderCostPercentageLabel: 'VEHICLE_PROFILES.FORM.ORDER_COST_PERCENTAGE_LABEL',
			weightCapacityPlaceholder: 'VEHICLE_PROFILES.FORM.WEIGHT_CAPACITY_PLACEHOLDER',
			numberNotInRange: 'OPTIMIZATION_CONFIGURATIONS.NUMBER_NOT_IN_RANGE',
			orderCostPercentageTooltip: 'VEHICLE_PROFILES.FORM.TOOLTIP.ORDER_COST_PERCENTAGE',
			overallCostPerMinuteTooltip: 'VEHICLE_PROFILES.FORM.TOOLTIP.OVERALL_COST_PER_MINUTE',
			costPerMinuteDrivingTooltip: 'VEHICLE_PROFILES.FORM.TOOLTIP.COST_PER_MINUTE_DRIVING',
			costPerKmTooltip: 'VEHICLE_PROFILES.FORM.TOOLTIP.COST_PER_KM',
			costPerRouteTooltip: 'VEHICLE_PROFILES.FORM.TOOLTIP.COST_PER_ROUTE',
			costPerTosTooltip: 'VEHICLE_PROFILES.FORM.TOOLTIP.COST_PER_TOS',
			costPerStopTooltip: 'VEHICLE_PROFILES.FORM.TOOLTIP.COST_PER_STOP',
			costPerMinuteWaitingTooltip: 'VEHICLE_PROFILES.FORM.TOOLTIP.COST_PER_MINUTE_WAITING'
		};
	}, [distance_unit]);

	// business requirement: if the translation for tooltip(help key) is missing, the tooltip should not be shown
	// no translation value => no tooltip rendered
	const translations = useMemo(
		() =>
			Object.entries(_translationKeys).reduce((acc, [key, value]) => {
				const isHelpTooltip = key.toLowerCase().includes('tooltip');
				const isComplexKey = Array.isArray(value);
				const translationKey = isComplexKey ? value[0] : value;

				let translatedValue: string;
				if (isComplexKey) {
					translatedValue = t(value[0] as string, value[1] as Record<string, unknown>);
				} else {
					translatedValue = t(value);
				}

				acc[key] = isHelpTooltip && translatedValue === translationKey ? null : translatedValue;

				return acc;
			}, {} as Record<keyof typeof _translationKeys, string | null>),
		[_translationKeys, t]
	);

	return translations;
}
